<style scoped>
</style>

<template>
  <div
    id="section_environment"
    class="section-environment"
    style="position: relative;"
  >
    <div class="SectionTable">
      <TemplateSectionRow
        v-for="(row, i) in rows"
        :key="i"
        :row="row"
      />
      <TemplateSectionRow emptyRow/>
    </div>

    <div
      v-for="(section, i) in section.sections"
      :key="i"
    >
      <TemplateSectionCenterResourceGroup
        v-if="section.id === 'section_currency'"
        :section="section"
      />
      <TemplateSectionCenterResourceGroup
        v-if="section.id === 'section_taxes' && enableTaxes"
        :section="section"
      />
      <!--
      <TemplateSectionCenterResourceGroup
        v-if="section.id === 'section_depreciation' && enableDepreciation"
        :section="section"
        :showResourceSelector="true"
      />
      -->
    </div>

    <TemplateSectionInflation
      v-if="enableInflation"
      :addResource="addResource"
    />
  </div>
</template>

<script>
import TemplateSectionRow from '@/components/sections/TemplateSection/TemplateSectionResourceTableRow';
import TemplateSectionCenterResourceGroup from '@/components/sections/TemplateSection/TemplateSectionCenterResourceGroup.vue';
/**/
import Mixin from '@/mixins/mixin';

export default {
  name: 'TemplateSectionEnvironment',
  components: {
    TemplateSectionRow,
    TemplateSectionCenterResourceGroup,
  },
  mixins: [Mixin],
  props: {
    isScrolled: Boolean,
    section: Object,
  },
  data() {
    return {
      scrollToNext: false,
      enableTaxes: true,
      enableInflation: false,
      sections: [],
      componentKey: 0, // to force update
    };
  },
  computed: {
    rows() {
      const rows = [];
      rows.push({}, {}, {
        className: 'row-subsection-header',
        content: this.section.title,
        units: 'ui_assumptions_columns__units',
        zeroPeriod: '"0"',
      });
      return rows;
    },
  },
  methods: {},
  mounted() {
    // if no wizard, display environment
    if (!this.$store.state.activeTemplate.isWizardEnabled) {
      this.$store.dispatch('updateState', {
        path: 'activeTemplate.data.sections[2].isVisible',
        value: true,
      });
    }
  },
};
</script>

<style scoped>

</style>
